import columns from '../../../../../react-table/helpers/columns';
import {sumRoundedTotal} from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    DateColumn,
    DateTimeColumn,
    FloatColumn,
    NumberColumn,
    TextColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);
  return [
    {
      Header: 'Despatch',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'predesMessage.despatchS8Id')
          .withTotalHeader('Total')
          .withWidth(195)),
        new TextColumn('Category', 'predesMessage.mailCategory'),
        new TextColumn('Class', 'predesMessage.mailSubClass'),
        new TextColumn('Day', 'predesMessage.despatchClosedDayOfWeek'),
        new DateTimeColumn('Close date', 'predesMessage.despatchClosedDateTime'),
        new DateColumn('Accounting date', 'predesMessage.accountingDateTime'),
        new NumberColumn('M-Bags', 'predesMessage.mBags'),
      ],
    },
    {
      Header: 'Transport',
      columns: [
        new NumberColumn('Legs', 'predesMessage.legCount'),
        new TextColumn('First leg', 'predesMessage.firstTransportLeg.name'),
        new DateTimeColumn('Planned departure', 'predesMessage.firstTransportLeg.scheduledLocalDateTime'),
        new TextColumn('Last leg', 'predesMessage.lastTransportLeg.name'),
        new DateTimeColumn('Planned arrival', 'predesMessage.lastTransportLeg.scheduledLocalDateTime'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NumberColumn('Count', 'predesReceptacleSummary.receptacleCount').withExcelFormatter('numberNumber')
          .withTotalHeader(sumRoundedTotal),
        new FloatColumn('Gross weight', 'predesReceptacleSummary.totalGrossWeight')
          .withExcelFormatter('numberNumber')
          .withTotalHeader(sumRoundedTotal),
        new FloatColumn('Net weight', 'predesReceptacleSummary.totalNetWeight')
          .withExcelFormatter('numberNumber')
          .withTotalHeader(sumRoundedTotal),
      ],
    },
  ];
};
